import React, { useEffect, useContext } from 'react';
import { useTranslation, Trans } from 'react-i18next';
import ReactTable from "react-table";
import CsvDownloader from 'react-csv-downloader';

//components 
import GridContainer from "beaktShared/components/Grid/GridContainer.js";
import GridItem from "beaktShared/components/Grid/GridItem.js";
import CardBody from "beaktShared/components/Card/CardBody.js";
import Button from "beaktShared/components/CustomButtons/Button.js";

import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";

//services
import { transformValueFloattoFormated } from "beaktShared/helpers/masks";
import { UsePostApi } from "beaktShared/services/crudeApiService";
import { SessionContext } from "beaktShared/services/session";

//styles
import styles from "assets/jss/material-dashboard-pro-react/views/dashboardStyle.js";
import { makeStyles } from "@material-ui/core/styles";
const useStyles = makeStyles(styles);


export default function VisualizarTodosRoyaltiesAjustados({ closemodal, showmodal }) {
  const { t } = useTranslation();
  const classes = useStyles();
  const session = useContext(SessionContext);
  const [notification, setNotification] = React.useState({
    show: false,
    color: 'info',
    message: ''
  });
  const showNotification = (message, color) => {
    setNotification({
      show: true,
      color: color,
      message: message
    });
    setTimeout(function () {
      setNotification({ show: false });
    }, 6000);
  };

  useEffect(() => {
    loadVisualizarTodosMinRoyaltiesReajustados();
  }, [showmodal])


  const [dadosMinRoyaltiesReajustados, setdadosMinRoyaltiesReajustados] = React.useState([]);
  const [loadingMinRoyaltiesReajustados, setloadingMinRoyaltiesReajustados] = React.useState([]);
  const [dataCSV, setdataCSV] = React.useState([]);

  const loadVisualizarTodosMinRoyaltiesReajustados = () => {
    setloadingMinRoyaltiesReajustados(true);
    const endPoint = "dashboard/GetReajusteLog/" + session.franquiaId + "/" + 0;
    UsePostApi(endPoint).then(result => {
      if (result.status !== 200) {
        showNotification(result.message, 'danger')
        setloadingMinRoyaltiesReajustados(false);
        return false;
      }

      setdadosMinRoyaltiesReajustados(result.data);
      setloadingMinRoyaltiesReajustados(false);

      //dados para CSV
      let dtCsv = [];
      result.data.map(item => {
        var obj = {
          estabelecimento: item.estabelecimento,
          aniversario: item.aniversario,
          minRoyaltiesAnterior: transformValueFloattoFormated(item.minRoyaltiesAnterior),
          minRoyaltiesCorrigido: transformValueFloattoFormated(item.minRoyaltiesCorrigido),
          taxaAnualAcumulada: transformValueFloattoFormated(item.taxaAnualAcumulada) + "%"
        }
        dtCsv.push(obj);
      })

      setdataCSV(dtCsv);

      return true;
    });
  }

  const columnsProps = [
    {
      Header: t('label.establishment'),
      accessor: "estabelecimento",
    },
    {
      Header: t('dashboard.month_year_birthday'),
      accessor: "aniversario",
    },
    {
      Header: t('dashboard.minRoyalties_previous'),
      accessor: "minRoyaltiesAnterior",
      Cell: (props) => <div> {transformValueFloattoFormated(props.value)} </div>
    },
    {
      Header: t('dashboard.minRoyalties_adjusted'),
      accessor: "minRoyaltiesCorrigido",
      Cell: (props) => <div> {transformValueFloattoFormated(props.value)} </div>    
    },
    {
      Header: t('dashboard.maxRoyalties_previous'),
      accessor: "maxRoyaltiesAnterior",
      Cell: (props) => <div> {transformValueFloattoFormated(props.value)} </div>
    },
    {
      Header: t('dashboard.maxRoyalties_adjusted'),
      accessor: "maxRoyaltiesCorrigido",
      Cell: (props) => <div> {transformValueFloattoFormated(props.value)} </div>    
    },
    {
      Header: t('dashboard.accrued_annual_fee'),
      accessor: "taxaAnualAcumulada",
      Cell: (props) => <div> {transformValueFloattoFormated(props.value) + "%"} </div>    
    },
  ]
  let columns = [...columnsProps];

  const handleCloseModalMinRoyaltiesReajustados = () => {
    closemodal(false);
  }

  // *******************************************************************************
  // ********************************** CABEÇALHO CSV **********************************
  // *******************************************************************************

  const columnsCSV = [
    { displayName: "Estabelecimento", id: "estabelecimento" },
    { displayName: "Mes/Ano - Aniversário", id: "aniversario" },
    { displayName: "Min. Royaltie Anterior", id: "minRoyaltiesAnterior" },
    { displayName: "Min. Royaltie Corrigido", id: "minRoyaltiesCorrigido" },
    { displayName: "% Taxa Anual Acumulada", id: "taxaAnualAcumulada" }
  ];

  return (
    <div>

      <Dialog
        classes={{
          root: classes.center + " " + classes.modalRoot,
          paper: classes.modal + ' ' + classes.modalLarge
        }}
        fullWidth
        maxWidth="lg"
        open={showmodal}
        keepMounted
        onClose={() => handleCloseModalMinRoyaltiesReajustados()}
        aria-labelledby="classic-modal-slide-title"
        aria-describedby="classic-modal-slide-description"
      >
        <DialogTitle
          id="classic-modal-slide-title"
          disableTypography
          className={classes.modalHeader}
          style={{ background: '#5c4477' }}
        >
          <h4 className={classes.modalTitle} style={{ color: 'white' }}>Todos os estabelecimentos que tiveram o reajuste do Min. Royalties</h4>
        </DialogTitle>
        <DialogContent id="classic-modal-slide-description"
          className={classes.modalBody}
        >
          <CardBody>
            <GridContainer>
              <GridItem xs={12} sm={12} md={12}>

                {dataCSV.length > 0 &&

                  <div>
                    <div style={{ float: 'right' }}>
                      <CsvDownloader
                        filename="MinRoyaltiesReajustados"
                        columns={columnsCSV}
                        datas={dataCSV}
                        separator={";"}>
                        <Button round color="default" size="sm" >CSV</Button>
                      </CsvDownloader>
                    </div><div style={{ clear: 'both' }}></div>
                  </div>
                }
              </GridItem>
            </GridContainer>
            <GridContainer>
              <GridItem xs={12} sm={12} md={12}>
                <ReactTable
                  loading={loadingMinRoyaltiesReajustados}
                  data={dadosMinRoyaltiesReajustados}
                  columns={columns}
                  filterable
                  // defaultFilterMethod={noCaseSensitive}
                  defaultPageSize={10}
                  minRows={5}
                  showPaginationBottom={true}
                  className="-striped -highlight"
                  previousText='Anterior'
                  nextText='Próximo'
                  loadingText='Carregando...'
                  noDataText='Nenhum registro encontrado!'
                  pageText='Página'
                  ofText='de'
                  rowsText='linhas'
                />
              </GridItem>
            </GridContainer>
          </CardBody>
        </DialogContent>
      </Dialog>

    </div>
  );
}
